export default __webpack_public_path__ + "static/iso-900-iso-14001-722e928b6c146b9c399a2ad354f65c38.gif";